<template>
  <div elevation="0" outlined class="mt-2">
    <!-- <div class="px-6 pt-5 pb-3 d-flex align-center flex-wrap" style="gap: 12px;">
      <v-btn color="primary" outlined elevation="0" small v-allowed="'edit_schedule'" @click="showAddClassParams()">
        {{ $t('message.add_class') }}
      </v-btn>
    </div> -->


    <div v-if="!loadingSchedule && hasClasses" class="px-0 pb-2">
      <v-expansion-panels v-model="scheduleDayPanel" flat class="academy-schedule-panels transparent">
        <v-expansion-panel elevation="0" v-for="d in daysWithClasses" :key="'day-panel-' + d" :class="[
          'academy-schedule-day-panel'
        ]">
          <v-expansion-panel-header class="font-roboto plusGreyDarken2--text text-subtitle-1 font-weight-regular">
            <div class="header_list">
              {{ dayTextFor(d) }} ({{ schedule[d].length }})
            </div>

          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-0">
            <ScheduleClassRow v-for="(c, hourIndex) in schedule[d]" :key="(c._id || '') + d + hourIndex" :class-data="c"
              :title="c.name" :day-text="dayTextFor(d)" :time-text="formatTimeRange(c)"
              :instructor-line="instructorLineFor(c)" :pricing-label="pricingLabelFor(c)"
              :participants-text="participantsTextFor(c)" :membership-label="membershipLabelFor(c)"
              :is-last="isLastClassRow(d, hourIndex)" @edit="editFromSchedule" @delete="onDeleteClass" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div v-else-if="loadingSchedule" class="pa-4">
      <v-skeleton-loader type="card" />
    </div>
    <div v-else class="pa-6">
      <div class="text-subtitle-1">{{ $t('message.schedule_explain1') }}</div>
      {{ $t('message.schedule_explain2') }} {{ $t('message.academies') }} {{ $t('message.schedule_explain3') }}
    </div>

    <v-dialog v-model="editClassDialog" width="90%">
      <v-card outlined>
        <v-card-actions>
          <h2>{{ $t('message.class') }}</h2>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="5">
              <v-text-field hide-details outlined dense :label="$t('message.class_title')" v-model="newClass.name" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select hide-details dense v-if="addingClass" :items="daysSelector" item-text="text" item-value="value"
                :label="$t('message.class_day')" v-model="newClass.day" outlined multiple />
              <v-select hide-details :disabled="true" dense v-else :items="daysSelector" item-text="text"
                item-value="value" :label="$t('message.class_day')" v-model="newClass.day" outlined />
            </v-col>
            <v-col cols="12" sm="2">
              <v-select hide-details dense :items="hours" v-model="newClass.start" item-text="display"
                item-value="value" :label="$t('message.class_start')" outlined />
            </v-col>
            <v-col cols="12" sm="2">
              <v-select hide-details dense :items="hours" v-model="newClass.end" item-text="display" item-value="value"
                :label="$t('message.class_end')" outlined />
            </v-col>
          </v-row>
          <v-row v-if="members && members.length > 0">
            <v-col cols="12">
              <v-autocomplete hide-details v-model="newClass.professorUser" :items="members"
                :label="$t('message.professor') + ' (' + $t('message.optional') + ')'" item-text="text"
                item-value="value" clearable outlined dense />
            </v-col>
          </v-row>
          <v-row v-if="members && members.length > 0">
            <v-col cols="12">
              <v-autocomplete multiple small-chips hide-details v-model="newClass.assistantProfessors" :items="members"
                :label="$t('message.assistant_professors') + ' (' + $t('message.optional') + ')'" item-text="text"
                item-value="value" clearable outlined dense />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="mb-0 pb-0">
              <v-textarea hide-details outlined dense v-model="newClass.details"
                :label="$t('message.details') + ' (' + $t('message.optional') + ')'" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="newClass.acceptVisitors" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('message.accept_visitors') }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t('message.accept_visitors_explained') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="newClass.free" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('message.free') }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t('message.free_class_explained') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="requireRegistration" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('message.require_registration') }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ $t('message.require_registration_explained') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div v-if="requireRegistration">
                <v-text-field hide-details outlined dense v-model="newClass.maxCapacity"
                  :label="$t('message.max_capacity')" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch dense hide-details v-model="showColorPicker" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('message.class_color') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('message.class_color_explained') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-color-picker v-if="showColorPicker" v-model="newClass.color" class="ml-12" dot-size="25"
                hide-mode-switch hide-inputs mode="hexa" show-swatches swatches-max-height="150" />
            </v-col>
          </v-row>
          <div v-if="error" class="error--text">{{ $t('message.fill_all_params') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="processing" outlined v-if="!editingClass" small color="primary" elevation="0"
            @click="addToSchedule()">
            <v-icon>mdi-plus-circle-outline</v-icon> {{ $t('message.add') }}
          </v-btn>
          <v-btn :loading="processing" v-else small outlined color="primary" elevation="0" @click="updateInSchedule()">
            <v-icon>mdi-square-edit-outline</v-icon>{{ $t('message.update') }}
          </v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click="showAddClassParams(true)">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
        <div class="text-caption pl-2">
          {{ $t('message.only_editing_one_class') }}
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/services/Api';
import ScheduleClassRow from './ScheduleClassRow.vue';

export default {
  name: 'AcademyScheduleList',
  components: {
    ScheduleClassRow
  },
  props: {
    value: null
  },
  data() {
    return {
      newClass: {},
      schedule: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      },
      loadingSchedule: false,
      members: [],
      hasClasses: false,
      updateMessage: null,
      selectedClassUsage: null,
      error: false,
      restrictedClasses: [],
      restrictedClassesUsage: {},
      addingClass: false,
      editingClass: false,
      processing: false,
      requireRegistration: false,
      showColorPicker: false,
      editClassDialog: null,
      scheduleDayPanel: 0,
      days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
      daysSelector: [
        { text: this.$t('message.monday'), value: 'monday' },
        { text: this.$t('message.tuesday'), value: 'tuesday' },
        { text: this.$t('message.wednesday'), value: 'wednesday' },
        { text: this.$t('message.thursday'), value: 'thursday' },
        { text: this.$t('message.friday'), value: 'friday' },
        { text: this.$t('message.saturday'), value: 'saturday' },
        { text: this.$t('message.sunday'), value: 'sunday' }
      ],
      hours: this.initializeHours()
    };
  },
  created() {
    this.scheduleTemplate = [];
    Api()
      .get('admins/academy/' + this.$store.state.selectedAcademy + '/members')
      .then((response) => {
        const data = response.data;
        if (data) {
          for (const m of data.approved) {
            this.members.push({ value: m._id, text: m.fName + ' ' + m.lName });
          }
        }
      });
    this.loadSchedule();
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    daysWithClasses() {
      return this.days.filter((d) => this.schedule[d] && this.schedule[d].length > 0);
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.schedule = newValue;
      }
    },
    'daysWithClasses.length'(len) {
      this.$nextTick(() => {
        const max = Math.max(0, len - 1);
        if (typeof this.scheduleDayPanel === 'number' && this.scheduleDayPanel > max) {
          this.scheduleDayPanel = max;
        }
      });
    }
  },
  methods: {
    dayTextFor(dayKey) {
      const map = {
        monday: this.$t('message.monday'),
        tuesday: this.$t('message.tuesday'),
        wednesday: this.$t('message.wednesday'),
        thursday: this.$t('message.thursday'),
        friday: this.$t('message.friday'),
        saturday: this.$t('message.saturday'),
        sunday: this.$t('message.sunday')
      };
      return map[dayKey] || dayKey;
    },
    formatTimeRange(c) {
      return (
        this.$d(this.numberToDate(c.start), 'time', this.$i18n.locale) +
        ' - ' +
        this.$d(this.numberToDate(c.end), 'time', this.$i18n.locale)
      );
    },
    instructorLineFor(c) {
      if (c.professorUser && this.members.length > 0) {
        const name = this.getProfessorName(c.professorUser);
        const extra =
          c.assistantProfessors && c.assistantProfessors.length
            ? ' (+' + c.assistantProfessors.length + ' ' + this.$t('message.more') + ')'
            : '';
        if (!name) return '—';
        return name + extra;
      }
      return '—';
    },
    pricingLabelFor(c) {
      return c.free ? this.$t('message.free') : this.$t('message.paid');
    },
    participantsTextFor(c) {
      const parts = [];
      if (c.details) {
        parts.push(this.$t('message.has_details'));
      }
      if (c.maxCapacity > 0) {
        parts.push(this.$t('message.max_capacity') + ': ' + c.maxCapacity);
      }
      if (parts.length === 0) {
        return '—';
      }
      return parts.join(' · ');
    },
    membershipLabelFor(c) {
      return c.acceptVisitors ? this.$t('message.accepting_visitors') : this.$t('message.members_only');
    },
    isLastClassRow(dayKey, hourIndex) {
      if (this.daysWithClasses.length === 0) return true;
      const lastDay = this.daysWithClasses[this.daysWithClasses.length - 1];
      if (dayKey !== lastDay) return false;
      const list = this.schedule[dayKey] || [];
      return hourIndex === list.length - 1;
    },
    onDeleteClass(classData) {
      if (classData && classData._id) {
        this.removeFromSchedule(classData._id);
      }
    },
    checkScheduleIds() {
      let fixSchedule = false;
      const days = Object.keys(this.schedule);
      if (days && days.length > 0) {
        for (const day of days) {
          const dayClasses = this.schedule[day];
          if (!dayClasses) continue;
          for (const c of dayClasses) {
            if (!c._id) fixSchedule = true;
            break;
          }
        }
      }
      if (fixSchedule) {
        console.log('We need to fix');
        this.updateSchedule(true);
      }
      return fixSchedule;
    },
    isRestricted(id) {
      if (this.restrictedClasses.indexOf(id) < 0) return false;
      return true;
    },
    loadSchedule() {
      this.loadingSchedule = true;
      Api()
        .get('admins/academy/' + this.$store.state.managedAcademy + '/schedule')
        .then((response) => {
          const data = response.data;
          if (data) {
            this.schedule = data.schedule;
            console.log('schedule', JSON.stringify(this.schedule));
            this.restrictedClasses = data.restricted;
            this.restrictedClassesUsage = data.usage;
            this.hasClasses = this.days.some((d) => this.schedule[d] && this.schedule[d].length > 0);
            const needsFixing = this.checkScheduleIds();
            if (needsFixing) {
              const vm = this;
              setTimeout(function () {
                vm.loadSchedule();
              }, 1000);
            } else {
              this.loadingSchedule = false;
            }
          } else {
            this.loadingSchedule = false;
          }
        })
        .catch(() => {
          this.loadingSchedule = false;
        });
    },
    getProfessorName(id) {
      if (this.members) {
        for (const m of this.members) {
          if (m.value == id) return m.text;
        }
      }
    },
    initializeHours() {
      const hours = [];
      for (let totalMinutes = 5 * 60; totalMinutes < 24 * 60; totalMinutes += 5) {
        const h = Math.floor(totalMinutes / 60);
        const m = totalMinutes % 60;
        const display = `${h}:${String(m).padStart(2, '0')}`;
        const value = parseFloat(`${h}.${String(m).padStart(2, '0')}`);
        hours.push({ display: display, value: value });
      }
      return hours;
    },
    numberToString(time) {
      const fixed = parseFloat(time).toFixed(2);
      const [h, m] = fixed.split('.');
      return `${h}:${m || '00'}`;
    },
    showAddClassParams(clear) {
      this.editingClass = false;
      this.newClass = {};
      this.newClass.name = null;
      this.newClass.day = null;
      this.newClass.start = null;
      this.newClass.end = null;
      this.newClass.details = null;
      this.newClass.color = null;
      this.requireRegistration = false;
      this.showColorPicker = false;
      if (clear) {
        this.editClassDialog = false;
      } else {
        this.editClassDialog = true;
        this.addingClass = true;
      }
    },
    addToSchedule() {
      this.error = false;
      if (!this.newClass.name || !this.newClass.day || !this.newClass.start || !this.newClass.end) {
        this.error = true;
        return;
      }
      if (Array.isArray(this.newClass.day)) {
        for (const day of this.newClass.day) {
          let dayClasses = this.schedule[day];
          if (!dayClasses) dayClasses = [];
          dayClasses.push({
            name: this.newClass.name,
            day: day,
            start: this.newClass.start,
            end: this.newClass.end,
            professorUser: this.newClass.professorUser,
            assistantProfessors: this.newClass.assistantProfessors,
            details: this.newClass.details,
            acceptVisitors: this.newClass.acceptVisitors,
            maxCapacity: this.newClass.maxCapacity,
            free: this.newClass.free,
            color: this.showColorPicker ? this.newClass.color?.hex || this.newClass.color : null
          });
          this.schedule[day] = this.sortedArray(dayClasses);
        }
      } else {
        let dayClasses2 = this.schedule[this.newClass.day];
        if (!dayClasses2) dayClasses2 = [];
        dayClasses2.push({
          name: this.newClass.name,
          day: this.newClass.day,
          start: this.newClass.start,
          end: this.newClass.end,
          professorUser: this.newClass.professorUser,
          assistantProfessors: this.newClass.assistantProfessors,
          details: this.newClass.details,
          acceptVisitors: this.newClass.acceptVisitors,
          maxCapacity: this.newClass.maxCapacity,
          free: this.newClass.free,
          color: this.showColorPicker ? this.newClass.color?.hex || this.newClass.color : null
        });
        this.schedule[this.newClass.day] = this.sortedArray(dayClasses2);
      }
      this.$emit('input', this.schedule);
      this.newClass = {};
      this.addingClass = false;
      this.hasClasses = true;
      this.updateSchedule();
    },
    updateInSchedule() {
      this.error = false;
      const classData = this.newClass;
      if (!this.newClass.name || !this.newClass.day || !this.newClass.start || !this.newClass.end) {
        this.error = true;
        return;
      }
      const dayClasses = this.schedule[classData.day];
      for (const c of dayClasses) {
        if (c._id == classData._id) {
          c.professorUser = classData.professorUser;
          c.assistantProfessors = classData.assistantProfessors;
          c.acceptVisitors = classData.acceptVisitors;
          c.details = classData.details;
          c.start = classData.start;
          c.end = classData.end;
          c.name = classData.name;
          c.maxCapacity = classData.maxCapacity;
          c.free = classData.free;
          c.color = this.showColorPicker ? classData.color?.hex || classData.color : null;
          if (!this.requireRegistration) c.maxCapacity = null;
          break;
        }
      }
      this.$emit('input', this.schedule);
      this.newClass = {};
      this.addingClass = false;
      this.hasClasses = true;
      this.editClassDialog = false;
      this.updateSchedule();
    },
    editFromSchedule(classData) {
      try {
        this.addingClass = false;
        this.newClass = {};
        this.newClass.name = classData.name;
        this.newClass.day = classData.day;
        this.newClass.start = classData.start;
        this.newClass.end = classData.end;
        this.newClass._id = classData._id;
        this.newClass.professorUser = classData.professorUser;
        this.newClass.assistantProfessors = classData.assistantProfessors;
        this.newClass.details = classData.details;
        this.newClass.acceptVisitors = classData.acceptVisitors;
        this.newClass.maxCapacity = classData.maxCapacity;
        this.newClass.free = classData.free;
        this.newClass.color = classData.color;
        if (classData.maxCapacity) this.requireRegistration = true;
        this.showColorPicker = !!classData.color;
        this.editingClass = true;
        this.editClassDialog = true;
      } catch (e) {
        if (e) console.log(e);
      }
    },
    removeFromSchedule(id) {
      const days = Object.keys(this.schedule);
      let found = false;
      if (days && days.length > 0) {
        for (const day of days) {
          const dayClasses = this.schedule[day];
          if (!dayClasses) continue;
          let index = 0;
          for (const c of dayClasses) {
            if (c._id == id) {
              dayClasses.splice(index, 1);
              found = true;
              break;
            }
            index++;
          }
        }
      }
      if (found) {
        this.hasClasses = this.days.some((d) => this.schedule[d] && this.schedule[d].length > 0);
        Api()
          .delete('admins/academy/' + this.$store.state.managedAcademy + '/schedule/' + id)
          .then(() => {
            this.showAlert('success', this.$t('message.updated'));
          })
          .catch((e) => {
            if (e) this.showAlert('error', 'Oops!', this.$t('message.error_generic'));
          });
      }
    },
    compare(a, b) {
      if (a.start < b.start) return -1;
      if (a.start > b.start) return 1;
      return 0;
    },
    sortedArray(array) {
      if (array) {
        return array.sort(this.compare);
      }
      return array;
    },
    numberToDate(time) {
      const fixed = parseFloat(time).toFixed(2);
      const [h, m] = fixed.split('.');
      const d = new Date();
      d.setHours(parseInt(h, 10));
      d.setMinutes(parseInt(m || '0', 10));
      d.setSeconds(0);
      return d;
    },
    updateSchedule(skipAlert) {
      try {
        this.processing = true;
        const data = [
          {
            propName: 'schedule',
            value: this.schedule
          }
        ];
        Api()
          .patch('admins/academy/' + this.$store.state.selectedAcademy, {
            values: data
          })
          .then((response) => {
            const res = response.data;
            if (res) {
              this.editingClass = false;
              this.editClassDialog = false;
              this.newClass.professorUser = null;
              this.newClass.assistantProfessors = null;
              this.newClass.details = null;
              this.newClass.acceptVisitors = null;
              this.newClass.maxCapacity = null;
              this.newClass.free = false;
              this.requireRegistration = false;
              this.processing = false;
              if (!skipAlert) this.showAlert('success', this.$t('message.updated'));
            }
          })
          .catch((e) => {
            if (e) this.showAlert('error', 'Oops!', this.$t('message.error_generic'));
          });
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped>
.academy-schedule-panels.transparent {
  background: transparent !important;
}

.academy-schedule-panels ::v-deep .v-expansion-panel:not(:last-child) {
  margin-bottom: 12px;
}

.academy-schedule-day-panel {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--grey-lighten-2, #E0E0E0);

}

.academy-schedule-day-header {
  min-height: 52px !important;
  padding: 12px 16px !important;
}

.academy-schedule-panels ::v-deep .v-expansion-panel--active .header_list {
  border-bottom: 1px solid var(--grey-lighten-2, #e0e0e0);
  padding-bottom: 24px !important;
  font-weight: 500;
  font-size: 20px;
}
</style>
